import C from "action-types";

export const requestImportTracking = data => {
  return {
    type: C.TRACKING.TRACKING_IMPORT,
    payload: data
  }
};
